function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React, { useCallback } from "react";
import cx from "classnames";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useUIDSeed } from "react-uid";
import { twMerge } from "../../../utils";
import { FormField } from "../../molecules";
var textInputTypes = {
    input: "text",
    email: "email",
    tel: "tel",
    number: "number",
    date: "date"
};
export function GenericForm(param) {
    var id = param.id, disabled = param.disabled, className = param.className, schema = param.schema, config = param.config, children = param.children, renderLayout = param.renderLayout, onSubmit = param.onSubmit;
    var seed = useUIDSeed();
    var ref = useForm({
        resolver: zodResolver(schema)
    }), register = ref.register, errors = ref.formState.errors, handleSubmit = ref.handleSubmit;
    var handleFinish = useCallback(function() {
        var _ref = _asyncToGenerator(function(values) {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit
    ]);
    var fieldGroups = config.map(function(group) {
        /*#__PURE__*/ return React.createElement("div", {
            key: seed(group)
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-start -m-3"
        }, group.map(function(field) {
            var key = seed(field);
            var allFieldProps = register(field.name);
            var ref = allFieldProps.ref, fieldProps = _objectWithoutProperties(allFieldProps, [
                "ref"
            ]);
            var sharedProps = {
                label: field.label,
                name: field.name,
                helpText: field.helpText,
                required: field.required,
                className: "m-3 grow"
            };
            if (field.type in textInputTypes || field.type === "checkbox") {
                var ref1, ref2;
                return /*#__PURE__*/ React.createElement(FormField, _extends({
                    key: key,
                    ref: ref,
                    type: field.type === "checkbox" ? "checkbox" : "input",
                    id: "".concat(id, "-").concat(field.name),
                    fieldProps: _objectSpreadProps(_objectSpread({}, fieldProps), {
                        disabled: disabled,
                        placeholder: field.placeholder,
                        type: field.type === "checkbox" ? "checkbox" : textInputTypes[field.type]
                    }),
                    error: (ref1 = errors[field.name]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.message) === null || ref2 === void 0 ? void 0 : ref2.toString()
                }, sharedProps));
            }
            if (field.type === "textarea") {
                var ref3, ref4;
                return /*#__PURE__*/ React.createElement(FormField, _extends({
                    key: key,
                    ref: ref,
                    id: "".concat(id, "-").concat(field.name),
                    type: "textarea",
                    fieldProps: _objectSpreadProps(_objectSpread({}, fieldProps), {
                        disabled: disabled,
                        rows: 5,
                        placeholder: field.placeholder
                    }),
                    error: (ref3 = errors[field.name]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.message) === null || ref4 === void 0 ? void 0 : ref4.toString()
                }, sharedProps));
            }
            if (field.type === "select") {
                var ref5, ref6;
                return /*#__PURE__*/ React.createElement(FormField, _extends({
                    key: key,
                    ref: ref,
                    id: "".concat(id, "-").concat(field.name),
                    type: "select",
                    options: field.options,
                    fieldProps: _objectSpreadProps(_objectSpread({}, fieldProps), {
                        disabled: disabled
                    }),
                    error: (ref5 = errors[field.name]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.message) === null || ref6 === void 0 ? void 0 : ref6.toString()
                }, sharedProps));
            }
            if (field.type === "radio") {
                var ref7, ref8;
                return /*#__PURE__*/ React.createElement(FormField, _extends({
                    key: key,
                    ref: ref,
                    id: "".concat(id, "-").concat(field.name),
                    type: "radio",
                    options: field.options,
                    fieldProps: _objectSpreadProps(_objectSpread({}, fieldProps), {
                        disabled: disabled
                    }),
                    error: (ref7 = errors[field.name]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.message) === null || ref8 === void 0 ? void 0 : ref8.toString()
                }, sharedProps));
            }
            if (field.type === "custom" && field.render) {
                return /*#__PURE__*/ React.createElement("div", {
                    key: key
                }, field.render(allFieldProps, errors));
            }
            return null;
        })));
    });
    return /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit(handleFinish),
        className: twMerge("grid grid-cols-1 gap-7 grid-flow-row auto-rows-auto", cx(className))
    }, renderLayout ? renderLayout(fieldGroups) : fieldGroups, children);
}

//# sourceMappingURL=GenericForm.js.map